export const messages = {
    "shared-link.footer.link.install": "무료 평가판 {brandName} 이용",
    "shared-link.footer.link.mobile": "{brandName} for Mobile",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "보호되는 데이터",
    "shared-link.password-dialog-box.message": "공유 폴더에 액세스하기 위한 비밀번호를 지정하십시오",
    "shared-link.password-dialog-box.hint.password": "암호",
    "shared-link.password-dialog-box.message.invalid-password": "비밀번호가 잘못되었습니다",
    "shared-link.form.button.open": "열기",
    "shared-link.page-not-found.title": "페이지를 찾을 수 없음",
    "shared-link.page-not-found.message.main": "찾고 있는 페이지가 없습니다.",
    "shared-link.page-not-found.message.description": "링크가 오래되었거나 주소를 잘못 입력했을 수 있습니다.",
    "shared-link.page-not-found.message.error": "오류 코드: 404",
    "shared-link.restore-file.label.size": "크기",
    "shared-link.restore-file.button.restore": "다운로드",
    "shared-link.links-table.column.name": "이름",
    "shared-link.links-table.column.size": "크기",
    "shared-link.links-table.action.restore": "다운로드",
    "shared-link.links-table.action.restore-all": "모두 다운로드",
    "shared-link.side-bar.selected.title:plural": "{count}개 항목 선택됨 | {count}개 항목 선택됨",
    "shared-link.links-table.label.size": "크기",
    "shared-link.links-table.message.empty-folder": "이 폴더가 비어 있습니다"
};
